/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";

//context
import { useSelectedStoreValue } from "../../context";

//custom libraries
import {
  CSR_CREATECUSTOMER,
  CSR_RESETPASSWORD,
  CSR_SEARCHCUSTOMER,
  CSR_CUSTOMER,
  METHOD,
  CSR_UPDATECUSTOMER_BY_ID,
  CSR_SEARCHCUSTOMER_V2,
  CSR_CUSTOMER_V2,
  SEARCH_USER_BY_LOOGON_ID_URL,
  CSR_RESETPASSWORD_V2,
} from "../../constants/requests";
import { useRestService } from "./use-rest-service";
import {
  LIMIT,
  REGISTERED_CUSTOMER_ROLE,
  STRING_STORE_ID,
} from "../../constants/common";

export const useCustomerHandler = () => {
  const { executeV2Request, executeRequest } = useRestService();

  const { selectedStore } = useSelectedStoreValue();

  const searchCustomerRequest = (parameters: any) => {
    if (!parameters.offset) {
      parameters.offset = 0;
    }
    let newParams = {
      ...parameters,
      limit: String(LIMIT),
      organizationRoleId: REGISTERED_CUSTOMER_ROLE,
      roleOrganizationId: selectedStore.ownerId,
    };
    const requestOptions: AxiosRequestConfig = {
      params: newParams,
      method: METHOD.GET,
      data: {},
      url: CSR_SEARCHCUSTOMER,
    };

    return executeV2Request(requestOptions);
  };

  const searchCustomerV2Request = (parameters: any) => {
    if (!parameters.offset) {
      parameters.offset = 0;
    }
    let newParams = {
      ...parameters,
      limit: String(LIMIT),
      organizationRoleId: REGISTERED_CUSTOMER_ROLE,
      roleOrganizationId: selectedStore.ownerId,
    };
    const requestOptions: AxiosRequestConfig = {
      params: newParams,
      method: METHOD.GET,
      data: {},
      url: CSR_SEARCHCUSTOMER_V2.replace("{storeId}", selectedStore.storeId),
      headers: {
        "Cache-Control": "no-cache",
      },
    };

    return executeRequest(requestOptions);
  };

  const updateCustomerRequest = (body: any, id: string) => {
    const requestOptions: AxiosRequestConfig = {
      method: METHOD.PATCH,
      data: body,
      url: CSR_CUSTOMER.replace("{id}", id),
    };
    return executeV2Request(requestOptions);
  };

  const updateCustomerV2Request = (body: any, id: string) => {
    const requestOptions: AxiosRequestConfig = {
      method: METHOD.PUT,
      data: body,
      url: CSR_UPDATECUSTOMER_BY_ID.replace(
        "{storeId}",
        selectedStore.storeId
      ).replace("{useId}", id),
    };
    return executeRequest(requestOptions);
  };

  const updateCustomerInfo = (body: any, id: string) => {
    const requestOptions: AxiosRequestConfig = {
      params: {},
      method: METHOD.PUT,
      data: body,
      url: CSR_UPDATECUSTOMER_BY_ID.replace(
        "{storeId}",
        selectedStore.storeId
      ).replace("{useId}", id),
    };
    return executeRequest(requestOptions);
  };

  const createCustomerRequest = (body: any) => {
    let queryParameters = new URLSearchParams();
    if (selectedStore) {
      queryParameters.set(STRING_STORE_ID, selectedStore.id);
    }
    const requestOptions: AxiosRequestConfig = {
      params: queryParameters,
      method: METHOD.POST,
      data: body,
      url: CSR_CREATECUSTOMER,
    };
    return executeV2Request(requestOptions);
  };

  const resetPasswordRequest = (id: string) => {
    let queryParameters = new URLSearchParams();
    if (selectedStore) {
      queryParameters.set(STRING_STORE_ID, selectedStore.id);
    }
    const requestOptions: AxiosRequestConfig = {
      params: queryParameters,
      method: METHOD.POST,
      data: {},
      url: CSR_RESETPASSWORD.replace("{id}", id),
    };
    return executeV2Request(requestOptions);
  };

  const resetPasswordV2Request = (logonId: string) => {
    const requestOptions: AxiosRequestConfig = {
      params: {},
      method: METHOD.POST,
      data: {
        logonId,
        URL: "test",
      },
      url: CSR_RESETPASSWORD_V2.replace("{storeId}", selectedStore.storeId),
    };
    return executeRequest(requestOptions);
  };

  const getCustomerByIdRequest = (id: string) => {
    let queryParameters = new URLSearchParams();
    if (selectedStore) {
      queryParameters.set(STRING_STORE_ID, selectedStore.id);
    }
    const requestOptions: AxiosRequestConfig = {
      params: queryParameters,
      method: METHOD.GET,
      url: CSR_CUSTOMER.replace("{storeId}", selectedStore.storeId).replace(
        "{id}",
        id
      ),
    };
    // return executeV2Request(requestOptions);
    return executeRequest(requestOptions);
  };

  const getCustomerByIdV2Request = (id: string) => {
    let queryParameters = new URLSearchParams();
    if (selectedStore) {
      queryParameters.set(STRING_STORE_ID, selectedStore.id);
    }
    const requestOptions: AxiosRequestConfig = {
      params: queryParameters,
      method: METHOD.GET,
      url: CSR_CUSTOMER_V2.replace("{storeId}", selectedStore.storeId).replace(
        "{id}",
        id
      ),
    };
    // return executeRequest(requestOptions);
    return executeV2Request(requestOptions);
  };

  const getCustomerByLogonIdRequest = (logonId: string) => {
    let queryParameters = new URLSearchParams();
    if (selectedStore) {
      queryParameters.set(STRING_STORE_ID, selectedStore.id);
    }
    const requestOptions: AxiosRequestConfig = {
      params: queryParameters,
      method: METHOD.GET,
      url: SEARCH_USER_BY_LOOGON_ID_URL.replace(
        "{storeId}",
        selectedStore.storeId
      ).replace("{logonId}", logonId),
      headers: {
        "Cache-Control": "no-cache",
      },
    };
    return executeRequest(requestOptions);
  };

  return {
    searchCustomerRequest,
    updateCustomerRequest,
    createCustomerRequest,
    resetPasswordRequest,
    getCustomerByIdRequest,
    updateCustomerInfo,
    searchCustomerV2Request,
    getCustomerByIdV2Request,
    getCustomerByLogonIdRequest,
    updateCustomerV2Request,
    resetPasswordV2Request,
  };
};
